import { ALL_CATEGORY_IDS, CATEGORY_IDS, CATEGORY_NAMES } from '@/constants'
import type { FilterOption } from '@/types/app-types'

export const CATEGORY_OPTIONS: FilterOption<CATEGORY_IDS | undefined>[] = [
    { label: 'All Types', value: undefined },
    ...ALL_CATEGORY_IDS.map((categoryId: CATEGORY_IDS) => ({
        label: CATEGORY_NAMES[categoryId],
        value: categoryId,
    })),
]
